import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-update',
  templateUrl: './success-update.component.html',
  styleUrls: ['./success-update.component.scss']
})
export class SuccessUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
